import { memo, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useQuery } from "@apollo/client";
import { useTranslation } from "next-i18next";
import { getPageFolderName, getPageTypes } from "@config/cms";
import { useStore } from "@hooks/useZustandProvider";
import { GET_ALL_PAGES_USER } from "@api/queriesV2/cms";
import { localizedDate } from "@utils/utils";
import s from './Latest.module.scss';
import i from "@styles/icons.module.scss";


const Latest = ({ type = 'news', count = 3, pageNumber = 1 }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { getBlockLocale } = useStore();
  const [list, setList] = useState([]);
  const lang = getBlockLocale(locale);

  useQuery(GET_ALL_PAGES_USER, {
    context: { clientName: "v2" },
    variables: {
      language: lang,
      type: getPageTypes()[type],
      pageNumber,
      pageSize: count,
    },
    onCompleted: (data) => {
      setList([...data.getAllPagesUser]);
    },
    onError: (error) => {
      toast.error(`[${error.name}]: ${error.message}`);
    }
  });

  let moreLink = '';
  let showMoreTranlsate = '';

  switch (type) {
    case getPageTypes().news:
      moreLink = '/blog';
      showMoreTranlsate = "cms.block.content.latest.more.news"
      break;
    case getPageTypes().story:
      moreLink = '/blog';
      showMoreTranlsate = "cms.block.content.latest.more.stories"
      break;
    case getPageTypes().destination:
      moreLink = '/all-destinations';
      showMoreTranlsate = "cms.block.content.latest.more.destinations"
      break;
    case getPageTypes().route:
      moreLink = '/all-routes';
      showMoreTranlsate = "cms.block.content.latest.more.routes"
      break;
    // case getPageTypes().promo:
    //   moreLink = '/promos';
  }

  return (
    <aside className={s.aside}>
      <h3>{t(showMoreTranlsate)}</h3>
      <div className={s.news}>
        {list.map((page, key) => {
          const slug = page.data.slug;
          const date = page.properties.datePublished;
          const title = page.data.seo.title;
          const description = page.data.seo.description;
          return (
            <Link className={s.item} key={key} href={`/${getPageFolderName()[type]}/${slug}`}>
              <div className={s.date}>
                {localizedDate(date, "dd MMMM yyyy", locale)}
              </div>
              <h5>{title}</h5>
              <p>{description}</p>
            </Link>
          );
        })}
      </div>
      <Link href={moreLink} className={s.showLatest}>
        {t("show more")}
        < icon className={i.arrowRight_v2} />
      </Link>
    </aside>
  )
}

export default memo(Latest);